const clientHost = window.location.hostname
const isLocalhost = clientHost === 'localhost'

const clientPort = isLocalhost ? window.location.port : null

// Use MKBACK_HOST environment variable if provided
const mkbackHostEnv = process.env.MKBACK_HOST

/**
 * Transform client hostname to server hostname using a mapping of domain patterns and transformation rules
 * @param hostname - The client hostname to transform
 * @return The transformed server hostname
 */
export const transformHostname = (hostname: string): string => {
  // Mapping of exact hostnames to their server equivalents
  const exactHostMap: Record<string, string> = {
    'stage-owner.sportsillustratedresorts.com': 'stage-mkback.tnlmako.com',
    'owner.sportsillustratedresorts.com': 'release-mkback.tnlmako.com',
    localhost: 'localhost',
  }

  // Mapping of domain patterns to transformation functions
  const domainPatternMap: Record<string, (host: string) => string> = {
    'tnlmako.com': (host) => host.replace(/^([^.]+)/, '$1-mkback'),
    'sportsillustratedresorts.com': (host) => host.replace(/^([^.]+)-owner/, '$1'),
    'eddiebaueradventureclub.com': (host) => host.replace(/^([^.]+)-owner/, '$1'),
    'cloudfront.net': (host) => host.replace(/^([^.]+)-owner/, '$1'),
    default: (host) => host.replace(/^([^.]+)/, '$1-api'),
  }

  // Check for exact hostname match first
  if (exactHostMap[hostname]) {
    return exactHostMap[hostname]
  }

  // Then check domain patterns
  for (const [domain, transformFn] of Object.entries(domainPatternMap)) {
    if (domain === 'default') continue
    if (hostname.endsWith(domain)) {
      return transformFn(hostname)
    }
  }

  // Default transformation
  return domainPatternMap.default(hostname)
}

const serverHost = mkbackHostEnv ? new URL(mkbackHostEnv).hostname : transformHostname(clientHost)

// serverHost = "https://stage.tnlmako.com/"

let serverPort = null
if (mkbackHostEnv) {
  const url = new URL(mkbackHostEnv)
  serverPort = url.port ? Number(url.port) : null
} else if (isLocalhost) {
  const portMapping: { [key: number]: number } = {
    3000: Number(process.env.MKBACK_PORT) || 3100,
    8000: 8100,
    3100: 3100,
    8100: 8100,
  }
  const clientPortNumber = Number(clientPort)
  if (![80, 443].includes(clientPortNumber)) {
    serverPort = portMapping[clientPortNumber] || clientPortNumber
  }
}

const clientUrl = `${window.location.protocol}//${clientHost}${clientPort ? `:${clientPort}` : ''}`

const serverUrl = mkbackHostEnv ? mkbackHostEnv : `${window.location.protocol}//${serverHost}${serverPort ? `:${serverPort}` : ''}`

const version = process.env.npm_package_version || 'none specified'
if (process.env.NODE_ENV !== 'test') {
  console.log(`Mako version: ${version}`)
  console.log(`T+L Stack: ${process.env.TNL_STACK}`)
  console.log(`clientUrl: ${clientUrl}`)
  console.log(`serverUrl: ${serverUrl}`)
  console.log(`NODE_ENV: ${process.env.NODE_ENV}`)
}

export { clientUrl, serverUrl }
